import { useTemplateContext } from '../context/TemplateContext';
const DemandTemplateCards = () => {
    const { openTemplateFormattingModal, openModal, openDemandTypeNameModal } = useTemplateContext();

    const cards = [
        {
            title: 'Template Formatting Settings',
            description: 'Update template formatting settings',
            actionText: 'Template Formatting Settings',
            onClick: openTemplateFormattingModal,
        },
        {
            title: 'Upload Document Template Menu',
            description: 'Use a pre-formatted word document as a template',
            actionText: 'Upload Template Menu',
            onClick: openModal,
        },
        {
            title: 'Demand Type Display Names',
            description: 'Customize how demand types appear across the platform',
            actionText: 'Update Names',
            onClick: openDemandTypeNameModal,
        },
    ];

    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10!">
            {cards.map(({ title, description, actionText, onClick }) => (
                <div key={title} className="info-card">
                    <h3>{title}</h3>
                    <p>{description}</p>
                    <span className="text-primary! cursor-pointer" onClick={onClick}>{actionText}</span>
                </div>
            ))}
        </div>
    );
};

export default DemandTemplateCards;
